export interface IName {
    name: string;
    slug: string | null;
    official: boolean;
    name_rank: number;
    name_root: string | null;
    name_prefix: string | null;
    display_name: string;
}

type TNames = Record<string, IName[]>;

interface ICoordinates {
    lat: number;
    lng: number;
}

export enum EPlaceTypes {
    Country = 'AD02',
    Municipality = 'AD08',
    Borough = 'AD09',
    Street = 'STRT',
    HouseNumber = 'HONU',
    PostalCode = 'POCO',
}

export enum EGeoCountry {
    France = 'FR',
    Germany = 'DE',
    Belgium = 'BE',
}

export type TPlaceTypes = `${EPlaceTypes}`;
export type TGeoCountry = `${EGeoCountry}`;

export interface IGeoPlace {
    id: string;
    area: number;
    type: string;
    level: number;
    names: TNames;
    active: boolean;
    language: string;
    type_key: EPlaceTypes;
    coordinates: ICoordinates;
    postal_codes: string[] | null;
    main_postal_code: string | null;
    parents?: IGeoPlace[] | null;
}

export interface IAutocompleteApiResponse {
    items: IGeoPlace[];
}

export interface IAutocompleteParams {
    text: string;
    countries?: TGeoCountry[];
    place_types?: TPlaceTypes[];
    limit?: number;
    parent_types?: TPlaceTypes[];
    parent_ids?: string[];
}

export interface IAutocompleteItem {
    city: string;
    houseNumber: string;
    id: string;
    label: string;
    name: string;
    postalCode: string | null;
    street: string;
    typeKey: EPlaceTypes | undefined;
}

export interface IFeedbackApiResponse {
    status: string;
}

export type IFeedbackParams =
    | {
          position: number;
          selected_id: string;
          input_string: string;
          subtype: 'COMPLETED';
          results_count?: number;
      }
    | {
          subtype: 'EXIT' | 'RESET';
          input_string: string;
      };

export interface IGeocodingParams {
    add_debug_events?: boolean;
    address: string;
    city: string;
    country?: 'AT' | 'BE' | 'CH' | 'DE' | 'FR';
    number: string;
    postal_code: string;
    providers?: ('aviv' | 'google' | 'mapbox')[];
}

export interface IGeocodingApiResponse {
    items: {
        aviv?: IGeoMatchItem[];
    };
}

export interface IGeoMatchItem {
    match: IGeoMatchPlace;
    provider_result: IGeoProviderResult;
}

export interface IGeoMatchPlace {
    confidence_score: number;
    coordinates?: ICoordinates;
    id: string;
    match_name: string;
    parents: IGeoMatchPlace[];
    type_key: TPlaceTypes;
}

export interface IGeoProviderResult {
    _source?: {
        data: {
            zips: string[];
        };
    };
    postal_code?: string;
    street_name?: string;
    no?: number;
    no_ext?: string;
}

export interface ILocationResult {
    id: string;
    typeKey: TPlaceTypes | undefined;
    postalCode: string;
    city: string;
    street: string;
    houseNumber: string;
}

export interface IClosestLocationResult extends ILocationResult {
    displayName: string;
}

export interface IClosestLocationSearch {
    houseNumber: string;
    street: string;
    postalCode: string;
    city: string;
}

interface ICoordinates {
    lat: number;
    lng: number;
}

export enum EOrdinalExtension {
    Ter = 'ter',
    Bis = 'bis',
    Quater = 'quarter',
    Quinque = 'quinque',
}
